import { collection, getDocs, addDoc, query, where, serverTimestamp } from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { db, storage } from "../firebase";

// Função para inicializar banners padrão caso não existam banners cadastrados
export const initDefaultBanners = async () => {
	try {
		// Verificar se já existem banners cadastrados
		const bannersRef = collection(db, "banners");
		const querySnapshot = await getDocs(bannersRef);

		if (querySnapshot.size === 0) {
			// Não existem banners, vamos adicionar os padrões
			// Como não podemos usar require() diretamente para URLs, vamos usar URLs estáticas
			// Estas URLs seriam normalmente geradas pelo Firebase Storage após upload
			const defaultBanners = [

			];

			// Adicionar banners padrão ao Firestore
			for (const banner of defaultBanners) {
				await addDoc(collection(db, "banners"), banner);
			}

			console.log("Banners padrão inicializados com sucesso!");
		}
	} catch (error) {
		console.error("Erro ao inicializar banners padrão:", error);
	}
};